// Filename: gani_token.js
// Timestamp: 2017.12.23-21:24:09 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const gnenumID = 'id'
const gnenumKEY = 'key'
const gnenumNODE = 'node'
const gnenumEDGE = 'edge'
const gnenumPATCH = 'patch'
const gnenumNAME = 'name'
const gnenumCHILD = 'child'
const gnenumSPEC = 'spec'
const gnenumTYPE = 'gn:type'
const gnenumNS = 'ns'

const gnenumNSSENDERS = 'nssenders'
const gnenumNSTARGETS = 'nstargets'

const gnenumKEYACTIVE = 'activekey'
const gnenumKEYFROM = 'datakeyprop'
const gnenumKEYBASEORIGIN = 'mapsrckey'

// dynamically-generated keys constructed with
// index position are prefixed "unsafe-"
const gnenumUNSAFE = 'unsafe'

const gnenumSPECNODETYPENAVPATH = 'ispathnode'
const gnenumSPECNODETYPES = 'spectypes'

const gnenumCHILDKEYNAME = 'childkeyname'
const gnenumCHILDKEYSDOM = 'childkeysdom'
const gnenumCHILDKEYS = 'childkeys'

// "onframe" is a function called on each frame of a `requestAnimationFrame`
// sequence for realtime animation. these keys are used to store a cache list
// of keys that belong to nodes defining onframe behaviour.
const gnenumONFRAMEKEYMAP = 'onframekeymap'
const gnenumONFRAMEKEYLIST = 'onframekeylist'

const gnenumISMODIFIEDTS = 'ismodifiedts'
const gnenumISPERSISTEDTS = 'ispersistedts'
const gnenumISPATCHREHYDRATE = 'ispatchrehydrate'
const gnenumISDOM = 'isdom'
const gnenumISDATA = 'isdata'

// The 'NAMEKEY' definition, from the parent pattern, becomes the 'name'
// defined to the child-node pattern, regardless of the name defined on the
// child pattern. Allows ui nodes to arrange childs in specific locations
// using the namekey
// ```
// {
//   child: [{
//     namekey: "loadslate",
//     spec: {
//       type: "local-ref",
//       path: "../user-loadslate/"
//     }
//   }]
// }
// ```
//
// div('.:pg-loadslate#:uid---loadslate', [
//   ndx.getchildvnode(sess, cfg, graph, node, 'loadslate')])
//
const gnenumSPECNODENAMEKEY = 'namekey'

const gnenumNSFKEY = 'fkey'
const gnenumNSBASEELEM = 'baseelem'
const gnenumNSBASE = 'base'
const gnenumNSSUBJ = 'subj'
const gnenumNSSUCH = 'such'
const gnenumNSINIT = 'init'
const gnenumNSFULL = 'full'
const gnenumNSPART = 'part'
const gnenumNSCACHE = 'cache'


const gnenumEDGEINDISABLE = 'edgein:disable'
const gnenumEDGEOUTDISABLE = 'edgeout:disable'

const gnenumISOLANG = 'Lang'
const gnenumISOREGION = 'Region'
const gnenumISOLOCALE = 'LangRegion'
const gnenumISOLOCALERe = /base(LangRegion|Lang|Region)/
const gnenumISOLOCALEPATHRe = /^\/([a-z]{2,3}?-[A-Z]{2})\//
const gnenumISOLOCALEIDREDIRECT = ':REDIRECT'

// `classNameNODE`, the node name rendered on the node's className. usually the
// node's given name is sufficient and this property is not used. In some cases,
// nodes are renamed to be unique among sibling nodes, and the original name
// can be defined classNameNODE so that it will render on the node's className
//
// `classNameROOT`, when defiined, is added to the className of the root vnode
//
const gnenumNSSUBJCLASSNAMENODE = 'classNameNODE'
const gnenumNSSUBJCLASSNAMEROOT = 'classNameROOT'
const gnenumNSSUBJMETATITLE = 'gnmetatitle'
const gnenumNSSUBJMETADESCRIPTION = 'gnmetadescription'

const gnenumPATHROOTDEFAULT = `$ROOTSPECS`
const gnenumPATHROOTSPECS = `${gnenumPATHROOTDEFAULT}/spec/`
const gnenumPATHROOTSPECSMANIFEST = `${gnenumPATHROOTSPECS}manifest.json`

const gnenumSELECTTYPESINGLE = 'single'
const gnenumSELECTTYPEMULTIPLE = 'multiple'

// About fkey "[./].baselem" hydration,
// ```
// fkey:
//   { dataitem: '[./].baseelem', '[./].baseelem': ['dataitem'] }
// fkeyhydrated:
//   { dataitem: '/data-users/2', '[./].baseelem': null }
// ```
//
// "[./].baselem" is a special-named-property at fkey,
//  * it is "pre-hydrated" at spec creation, outside common node hydration,
//    * an important restriction --prevent nodes from using this directly
//  * it is pre-hydrated around "baseelem" data, not given to node hydration,
//  * it is pre-hydrated with baseelem-only properties,
//  * assigning pre-hydrated fkeys writes baselem properties only,
//  * `fkeyhydrated['[./].baselem'] === null` indicates hydrated baselem
//  * pre-hydrated fkey values are lost by regular fkey-hydration below,
//  * regular fkey-hydration can re-assign pre-hydrated fkeys to keep them
//
// fkey spec pre-hydrated
//  -> regular fkey hydration erases spec pre-hydrated
//     -> spec pre-hydrated is assigned back into fkey hydrated
//
// sequence seems clumsy but is not terrible,
//  * this flow avoids separate branches of hydration logic for baselem,
//  * restated above; continue using one prehydration sequence for all nodes,
//  * avoids using and managing new fields to handle baseelem
//  * addl. operations apply practically only to baselem-referencing nodes,
//  * baseelem-referencing nodes occur less frequently,
//  * hydrated fkey always a plain object, natural to use with 'assign',
//
// to remove special-case baseelem behaviour here, support for baselem could
// be restricted to spec-wrapping childs, auto-created at spec-generation
// ```diff
// - child[{ fkey: { ...fkeybaselem }, node, name }]
// + child[{ fkey: { ...fkeybaselem }, spec: { node, name }]
// ```
const gnenumNSFKEYBASEELEM = '[./].baseelem'

// value with this 'type' indicates a full value defined elsewhere that is
// local to page-deploy specs
//
// ```
// {
//   "gn:type": "local-ref",
//   "path": "../root-content-foot/eng.json"
// }
// ```
const gnenumSPECNODETYPEPATHLOCALREF = 'local-ref'

// 'prefixdir' distinguishes two different web-app scenarious
//  1. served from origin root, ex "myapp.com/"
//  2. served from prefix root, ex "myapp.com/prefix-dir/"
//
// for example, gitlab and github pages are served from a prefix,
//  * github.com/user54/touchboom uses prefix "touchboom"
//    * https://user54.github.io/touchboom/
//  * gitlab.com/user54/app.gani uses prefix "app.gani"
//    * https://user54.gitlab.io/app.gani/
//
// gani requests and reads files relative to the location of $ROOTSPECS
// when "prefixdir" is defined, it becomes expected rootpath for $ROOTSPECS
const gnenumCFGPROPTYPEPREFIXDIR = 'prefixdir'
const gnenumCFGWEBFPMS = 'fpms'

const gnenumSESSLOCALE = 'locale'
const gnenumSESSREQURL = 'requrl'


// ISOPTIMISED represents a list that uses the literal values for
// all partial values. ex,
// ```
// ['Baseball', 'Golf', 'Tennis']
// ```
// The first element uses 'Baseball' as return, fullkey,
// subjkey and partkey
const gnenumPARTISOPTIMISED = 'isoptimised'
const gnenumPARTKEYFULLTYPE = 'keyfulltype'

// "part" (or partial, or multipart) nodes, comprise two data,
//   1. "full", or original data that derive lsit of 'parts' and
//   2. "part", or partial data derived from 'full' data
//
// for example,
// ```json
// {
//   full: [
//     { name: 'baseball', id: 123 },
//     { name: 'football', id: 456 },
//     { name: 'handball', id: 789 }]
//   part: [
//     { label: 'baseball', [KEYFULL]: 123, [KEYPART]: 123 },
//     { label: 'football', [KEYFULL]: 123, [KEYPART]: 345 },
//     { label: 'handball', [KEYFULL]: 123, [KEYPART]: 789 }]
// }
// ```
//
// a single "part",
// ```json
// {
//   [KEYLABEL]: 'football',
//   [KEYFULL]: 123,
//   [KEYPART]: '345',
//   [KEYRETURN]: 'FOOTBALL-r1'
// }
// ```
//
// KEYFULL: a unique and primitive value resolved from a "full"
//          element usable as a "key"; "part[KEYFULL]" links the part
//          to its corresponding "full" element. ex, `345`
//
// KEYPART: a unique and primitive value representing a specific "part"
//          element. "part[KEYPART]" can be used w/ dom events to
//          reverse-lookup a "part" from a dom `event.target`
//
// RETURN: for multipart nodes resolving a solection of one or more parts,
//         'RETURN' is a final value resolved from a part. It does not need
//         to be a unique or DOM-safe value, but it should be valid within
//         the context of any corresponding subj value data-node subj value
//         reactively linked to the node
//
// KEYSUBJ: (note: though customizeable, this value is used internally-only)
//          a value resolved from the subj namespace corresponding to the
//          RETURN value(s) of selected parts. Used to determine which parts
//          are "selected" and not. A part is selected when "part[RETURN]"
//          matches the resolved KEYSUBJ
//
// KEYDOC: a DOM-friendly value that serializes details uniquely identifying
//         the node and "part" within the graph. used w/ dom events to
//         reverse-lookup a "part" from a dom `event.target`
//
// KEYNODE: key of the node that defines the "part". part[KEYNODE] often used
//          when multi-value form-controls need to declare a single "name".
const gnenumPARTKEYFULL = 'fullkey'
const gnenumPARTKEYSUBJ = 'subjkey'
const gnenumPARTKEYPART = 'partkey'
const gnenumPARTKEYRETURN = 'return'
const gnenumPARTKEYDOC = 'dockey'
const gnenumPARTKEYNODE = 'nodekey'
const gnenumPARTISACTIVE = 'isactive'
const gnenumPARTLABEL = 'label'

// input types compatible w/ similar behaviour to 'text'
const gnenumINPUTTYPEPASSWORD = 'password'
const gnenumINPUTTYPENUMBER = 'number'
const gnenumINPUTTYPESEARCH = 'search'
const gnenumINPUTTYPEWEEK = 'week'
const gnenumINPUTTYPETIME = 'time'
const gnenumINPUTTYPETEXT = 'text'
const gnenumINPUTTYPEURL = 'url'
const gnenumINPUTTYPETEL = 'tel'

const gnenumXINIT = 'xinit'
const gnenumXRESET = 'xreset'
const gnenumXVNODE = 'xvnode'

const gnenumXHYDRATEDBASE = 'xhydratedbase'
const gnenumXHYDRATEDSUBJ = 'xhydratedsubj'
const gnenumXONSUBJ = 'xonsubj'
const gnenumXONFRAME = 'xonframe'
const gnenumXONATTACH = 'xonattach'
const gnenumXONCHILDADD = 'xonchildadd'
const gnenumXONCHILDADDED = 'xonchildadded'
const gnenumXONCHILDREMOVE = 'xonchildremove'
const gnenumXONCHILDREMOVED = 'xonchildremoved'
const gnenumXONINPUT = 'xoninput'
const gnenumXONKEYUP = 'xonkeyup'
const gnenumXONCHANGE = 'xonchange'
const gnenumXONSUBMIT = 'xonsubmit'
const gnenumXONCLICK = 'xonclick'

const gnenumLOGPATCHJOBS = 'patchjobs'
const gnenumLOGREPORTS = 'reports'
const gnenumLOGWARNINGS = 'warnings'

export {
  gnenumID,
  gnenumKEY,
  gnenumNODE,
  gnenumEDGE,
  gnenumPATCH,
  gnenumTYPE,
  gnenumNAME,
  gnenumSPEC,

  gnenumKEYACTIVE,
  gnenumKEYFROM,
  gnenumKEYBASEORIGIN,

  gnenumUNSAFE,

  gnenumISDOM,
  gnenumISDATA,

  gnenumSPECNODETYPES,
  gnenumSPECNODETYPENAVPATH,
  gnenumSPECNODENAMEKEY,
  gnenumSPECNODETYPEPATHLOCALREF,

  gnenumCHILDKEYNAME,
  gnenumCHILDKEYSDOM,
  gnenumCHILDKEYS,

  gnenumONFRAMEKEYMAP,
  gnenumONFRAMEKEYLIST,

  gnenumISMODIFIEDTS,
  gnenumISPERSISTEDTS,
  gnenumISPATCHREHYDRATE,

  gnenumNSSENDERS,
  gnenumNSTARGETS,

  gnenumNS,
  gnenumNSCACHE,
  gnenumNSFKEY,
  gnenumNSBASEELEM,
  gnenumNSBASE,
  gnenumNSSUBJ,
  gnenumNSSUCH,
  gnenumNSINIT,
  gnenumNSFULL,
  gnenumCHILD,
  gnenumNSPART,
  gnenumNSFKEYBASEELEM,

  gnenumEDGEINDISABLE,
  gnenumEDGEOUTDISABLE,

  gnenumISOLANG,
  gnenumISOREGION,
  gnenumISOLOCALE,
  gnenumISOLOCALERe,
  gnenumISOLOCALEPATHRe,
  gnenumISOLOCALEIDREDIRECT,

  gnenumNSSUBJCLASSNAMENODE,
  gnenumNSSUBJCLASSNAMEROOT,
  gnenumNSSUBJMETATITLE,
  gnenumNSSUBJMETADESCRIPTION,

  gnenumPATHROOTDEFAULT,
  gnenumPATHROOTSPECS,
  gnenumPATHROOTSPECSMANIFEST,

  gnenumSELECTTYPESINGLE,
  gnenumSELECTTYPEMULTIPLE,

  gnenumCFGPROPTYPEPREFIXDIR,
  gnenumCFGWEBFPMS,

  gnenumSESSLOCALE,
  gnenumSESSREQURL,

  gnenumPARTISOPTIMISED,
  gnenumPARTKEYFULLTYPE,
  gnenumPARTKEYFULL,
  gnenumPARTKEYSUBJ,
  gnenumPARTKEYPART,
  gnenumPARTKEYRETURN,
  gnenumPARTKEYDOC,
  gnenumPARTKEYNODE,
  gnenumPARTISACTIVE,
  gnenumPARTLABEL,

  gnenumINPUTTYPEPASSWORD,
  gnenumINPUTTYPENUMBER,
  gnenumINPUTTYPESEARCH,
  gnenumINPUTTYPEWEEK,
  gnenumINPUTTYPETIME,
  gnenumINPUTTYPETEXT,
  gnenumINPUTTYPEURL,
  gnenumINPUTTYPETEL,

  gnenumXINIT,
  gnenumXRESET,
  gnenumXVNODE,
  gnenumXONSUBJ,
  gnenumXONFRAME,
  gnenumXONATTACH,
  gnenumXHYDRATEDBASE,
  gnenumXHYDRATEDSUBJ,
  gnenumXONCHILDADD,
  gnenumXONCHILDADDED,
  gnenumXONCHILDREMOVE,
  gnenumXONCHILDREMOVED,
  gnenumXONINPUT,
  gnenumXONKEYUP,
  gnenumXONCHANGE,
  gnenumXONSUBMIT,
  gnenumXONCLICK,

  gnenumLOGPATCHJOBS,
  gnenumLOGREPORTS,
  gnenumLOGWARNINGS
}
